import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { APP_ROUTES } from './core/enum/app-routes.enum';
import { UserRole } from './core/enum/user-role.enum';
import { AuthorizationGuard } from './core/guards/authorization.guard';
import { RoleGuard } from './core/guards/role.guard';

const routerOptions: ExtraOptions = {
    anchorScrolling: 'enabled',
};

const routes: Routes = [
    {
        path: '',
        redirectTo: `/${APP_ROUTES.LOGIN}`,
        pathMatch: 'full',
    },
    {
        path: APP_ROUTES.TOTAL_REPORT,
        loadChildren: () =>
            import('./pages/total-report/total-report.routes').then(
                (mod) => mod.TOTAL_REPORT_ROUTES,
            ),
        canActivate: [AuthorizationGuard],
    },
    {
        path: APP_ROUTES.BRANDS,
        loadChildren: () =>
            import('./pages/brands/brands.routes').then(
                (mod) => mod.BRANDS_ROUTES,
            ),
        canActivate: [
            AuthorizationGuard,
            RoleGuard([UserRole.Administrator, UserRole.BrandAdmin]),
        ],
    },
    {
        path: APP_ROUTES.AUTHORITIES,
        loadChildren: () =>
            import('./pages/authorities/authorities.routes').then(
                (mod) => mod.AUTHORITIES_ROUTES,
            ),
        canActivate: [
            AuthorizationGuard,
            RoleGuard([UserRole.Administrator, UserRole.BrandAdmin]),
        ],
    },
    {
        path: APP_ROUTES.SUMMARY_REPORT,
        loadChildren: () =>
            import('./pages/summary-report/summary-report.routes').then(
                (mod) => mod.SUMMERY_REPORT_ROUTES,
            ),
        canActivate: [AuthorizationGuard],
    },
    {
        path: APP_ROUTES.TOTAL_REPORT_UGANDA,
        loadChildren: () =>
            import('./pages/uganda/total-report-uganda/total-report-uganda.routes').then(
                (mod) => mod.TOTAL_REPORT_UGANDA_ROUTES,
            ),
        canActivate: [
            AuthorizationGuard,
            RoleGuard([UserRole.Administrator, UserRole.BrandAdmin]),
        ],
    },
    {
        path: APP_ROUTES.USER_SUMMARY_REPORT,
        loadChildren: () =>
            import('./pages/user-summary-report/user-summary-report.routes').then(
                (mod) => mod.USER_SUMMERY_REPORT_ROUTES,
            ),
        canActivate: [AuthorizationGuard],
    },
    {
        path: APP_ROUTES.RWANDA_SUMMARY,
        loadChildren: () =>
            import('./pages/rwanda/summary-report-rwanda/summary-report-rwanda.routes').then(
                (mod) => mod.SUMMERY_REPORT_RWANDA_ROUTES,
            ),
        canActivate: [AuthorizationGuard],
    },
    {
        path: APP_ROUTES.TANZANIA_SUMMARY,
        loadChildren: () =>
            import('./pages/tanzania/summary-report-tanzania/summary-report-tanzania.routes').then(
                (mod) => mod.SUMMERY_REPORT_TANZANIA_ROUTES,
            ),
        canActivate: [AuthorizationGuard],
    },
    {
        path: APP_ROUTES.CONGO_SUMMARY,
        loadChildren: () =>
            import('./pages/congo/summary-report-congo/summary-report-congo.routes').then(
                (mod) => mod.SUMMERY_REPORT_CONGO_ROUTES,
            ),
        canActivate: [AuthorizationGuard],
    },
    {
        path: APP_ROUTES.MALAWI_SUMMARY,
        loadChildren: () =>
            import('./pages/malawi/summary-report-malawi/summary-report-malawi.routes').then(
                (mod) => mod.SUMMERY_REPORT_MALAWI_ROUTES,
            ),
        canActivate: [AuthorizationGuard],
    },
    {
        path: APP_ROUTES.SUMMARY_REPORT_ZIMBABWE,
        loadChildren: () =>
            import('./pages/zimbabwe/summary-report-zimbabwe/summary-report-zimbabwe.routes').then(
                (mod) => mod.SUMMERY_REPORT_ZIMBABWE_ROUTES,
            ),
        canActivate: [AuthorizationGuard],
    },
    {
        path: APP_ROUTES.SUMMARY_REPORT_ZIMBABWEMWOS,
        loadChildren: () =>
            import('./pages/zimbabwemwos/summary-report-zimbabwemwos/summary-report-zimbabwemwos.routes').then(
                (mod) => mod.SUMMERY_REPORT_ZIMBABWEMWOS_ROUTES,
            ),
        canActivate: [AuthorizationGuard],
    },
    {
        path: APP_ROUTES.TOTAL_REPORT_BURUNDI,
        loadChildren: () =>
            import('./pages/burundi/total-report-burundi/total-report-burundi.routes').then(
                (mod) => mod.TOTAL_REPORT_BURUNDI_ROUTES,
            ),
        canActivate: [
            AuthorizationGuard,
            RoleGuard([UserRole.Administrator, UserRole.BrandAdmin]),
        ],
    },

    {
        path: APP_ROUTES.SUMMARY_REPORT_BURUNDI,
        loadChildren: () =>
            import('./pages/burundi/summary-report-burundi/summary-report-burundi.routes').then(
                (mod) => mod.SUMMERY_REPORT_BURUNDI_ROUTES,
            ),
        canActivate: [AuthorizationGuard],
    },
    {
        path: APP_ROUTES.ONLINE_MALAWI,
        loadChildren: () =>
            import('./pages/malawi/online-malawi/online-malawi.routes').then(
                (mod) => mod.ONLINE_MALAWI_ROUTES,
            ),
        canActivate: [
            AuthorizationGuard,
            RoleGuard([UserRole.Administrator, UserRole.BrandAdmin]),
        ],
    },
    {
        path: APP_ROUTES.SAVE_SEARCH,
        loadChildren: () =>
            import('./pages/save-search/save-search.routes').then(
                (mod) => mod.SAVE_SEARCH_ROUTES,
            ),
        canActivate: [AuthorizationGuard],
    },
    {
        path: APP_ROUTES.DASHBOARD,
        loadChildren: () =>
            import('./pages/dashboard/dashboard.routes').then(
                (mod) => mod.DASHBOARD_ROUTES,
            ),
        canActivate: [AuthorizationGuard, RoleGuard([UserRole.Administrator])],
    },
    {
        path: APP_ROUTES.SETTINGS,
        loadChildren: () =>
            import('./pages/settings/settings.routes').then(
                (mod) => mod.SETTINGS_ROUTES,
            ),
        canActivate: [AuthorizationGuard, RoleGuard([UserRole.Administrator])],
    },
    {
        path: APP_ROUTES.TAX_REPORTING,
        loadChildren: () =>
            import('./pages/tax-reporting/tax-reporting.routes').then(
                (mod) => mod.TAX_REPORTING_ROUTES,
            ),
        canActivate: [AuthorizationGuard],
    },
    {
        path: APP_ROUTES.NOTIFICATION_HISTORY,
        loadChildren: () =>
            import('./pages/notification-history/notification-history.routes').then(
                (mod) => mod.NOTIFICATION_HISTORY_ROUTES,
            ),
        canActivate: [
            AuthorizationGuard,
            RoleGuard([UserRole.Administrator, UserRole.BrandAdmin]),
        ],
    },
    {
        path: APP_ROUTES.API_LOG,
        loadChildren: () =>
            import('./pages/api-log/api-log.routes').then(
                (mod) => mod.API_LOG_ROUTES,
            ),
        canActivate: [
            AuthorizationGuard,
            RoleGuard([UserRole.Administrator, UserRole.BrandAdmin]),
        ],
    },
    {
        path: APP_ROUTES.LOAD_DATA,
        loadChildren: () =>
            import('./pages/load-data-log/load-datai-log.routes').then(
                (mod) => mod.LOAD_DATA_LOG_ROUTES,
            ),
        canActivate: [
            AuthorizationGuard,
            RoleGuard([UserRole.Administrator, UserRole.BrandAdmin]),
        ],
    },
    {
        path: APP_ROUTES.REPORTS_LOG,
        loadChildren: () =>
            import('./pages/reports-log/reports-log.routes').then(
                (mod) => mod.REPORTS_LOG_ROUTES,
            ),
        canActivate: [
            AuthorizationGuard,
            RoleGuard([UserRole.Administrator, UserRole.BrandAdmin]),
        ],
    },
    {
        path: APP_ROUTES.CRITICAL_ALERT_HISTORY,
        loadChildren: () =>
            import('./pages/critical-alert-history/critical-alert-history.routes').then(
                (mod) => mod.CRITICAL_ALERT_HISTORY_ROUTES,
            ),
        canActivate: [
            AuthorizationGuard,
            RoleGuard([UserRole.Administrator, UserRole.BrandAdmin]),
        ],
    },

    {
        path: APP_ROUTES.USER_LOGS_HISTORY,
        loadChildren: () =>
            import('./pages/user-logs-history/user-logs-history.routes').then(
                (mod) => mod.USER_LOGS_HISTORY_ROUTES,
            ),
        canActivate: [
            AuthorizationGuard,
            RoleGuard([UserRole.Administrator, UserRole.BrandAdmin]),
        ],
    },
    {
        path: APP_ROUTES.TOTAL_REPORT_TANZANIA,
        loadChildren: () =>
            import('./pages/tanzania/total-report-tanzania/total-report-tanzania.routes').then(
                (mod) => mod.TOTAL_REPORT_TANZANIA_ROUTES,
            ),
        canActivate: [
            AuthorizationGuard,
            RoleGuard([UserRole.Administrator, UserRole.BrandAdmin]),
        ],
    },
    {
        path: APP_ROUTES.TOTAL_REPORT_CONGO,
        loadChildren: () =>
            import('./pages/congo/total-report-congo/total-report-congo.routes').then(
                (mod) => mod.TOTAL_REPORT_CONGO_ROUTES,
            ),
        canActivate: [
            AuthorizationGuard,
            RoleGuard([UserRole.Administrator, UserRole.BrandAdmin]),
        ],
    },
    {
        path: APP_ROUTES.TOTAL_REPORT_RWANDA,
        loadChildren: () =>
            import('./pages/rwanda/total-report-rwanda/total-report-rwanda.routes').then(
                (mod) => mod.TOTAL_REPORT_RWANDA_ROUTES,
            ),
        canActivate: [
            AuthorizationGuard,
            RoleGuard([UserRole.Administrator, UserRole.BrandAdmin]),
        ],
    },
    {
        path: APP_ROUTES.TOTAL_REPORT_ZAMBIA,
        loadChildren: () =>
            import('./pages/zambia/total-report-zambia/total-report-zambia.routes').then(
                (mod) => mod.ZAMBIA_TR_ROUTES,
            ),
        canActivate: [
            AuthorizationGuard,
            RoleGuard([UserRole.Administrator, UserRole.BrandAdmin]),
        ],
    },
    {
        path: APP_ROUTES.TOTAL_REPORT_ZIMBABWE,
        loadChildren: () =>
            import('./pages/zimbabwe/total-report-zimbabwe/total-report-zimbabwe.routes').then(
                (mod) => mod.TOTAL_REPORT_ZIMBABWE_ROUTES,
            ),
        canActivate: [
            AuthorizationGuard,
            RoleGuard([UserRole.Administrator, UserRole.BrandAdmin]),
        ],
    },
    {
        path: APP_ROUTES.TOTAL_REPORT_ZIMBABWEMWOS,
        loadChildren: () =>
            import('./pages/zimbabwemwos/total-report-zimbabwemwos/total-report-zimbabwemwos.routes').then(
                (mod) => mod.TOTAL_REPORT_ZIMBABWEMWOS_ROUTES,
            ),
        canActivate: [
            AuthorizationGuard,
            RoleGuard([UserRole.Administrator, UserRole.BrandAdmin]),
        ],
    },
    {
        path: APP_ROUTES.SUMMARY_REPORT_ZAMBIA,
        loadChildren: () =>
            import('./pages/zambia/summary-report-zambia/summary-report-zambia.routes').then(
                (mod) => mod.ZAMBIA_SR_ROUTES,
            ),
        canActivate: [AuthorizationGuard],
    },
    {
        path: APP_ROUTES.ERROR,
        loadChildren: () =>
            import('./pages/error/error.routes').then(
                (mod) => mod.ERROR_ROUTES,
            ),
        canActivate: [
            AuthorizationGuard,
            RoleGuard([UserRole.Administrator, UserRole.BrandAdmin]),
        ],
    },
    {
        path: APP_ROUTES.LOGIN,
        loadComponent: () =>
            import('./pages/auth/login/login.component').then(
                (module) => module.LoginComponent,
            ),
    },
    { path: '**', redirectTo: `/${APP_ROUTES.LOGIN}` },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
